import useStyles from "../../assets/styles/styles";
import { Grid, Typography, Divider, IconButton, CircularProgress, Box } from "@material-ui/core";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import CustomButton from "../../controls/Button/CustomButton";
import { useEffect, useLayoutEffect, useState } from "react";
import MapContainer from "../../components/MapContainer/MapContainer";
import { useDispatch, useSelector } from "react-redux";
import { cleanModelMedicalRecords, getFiltersValues, getPerfilCompleto } from "../../redux/actions/medicalRecords";
import { getFullData } from "../../redux/actions/personalDataActions";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SelectTypeOfComponent from "../../components/PersonalData/SelectTypeOfComponent";
import { useHistory, useLocation } from "react-router";
import { getLimitPlan } from "../../redux/actions/limitPlansAction";
import { verifyPermission, notAccessToThisModule } from "../../utils/utilsFunctions";
import useTrackPageView from "../../utils/useTrackPageView";
import MedicalFiltersExternal from "../../components/MedicalFilters/MedicalFiltersExternal";

const param = {
  parametroLlamado: ''
};

const Cartilla = () => {
  const classes = useStyles();
  const { screen } = useResizeScreen();
  const dispatch = useDispatch();
  const medicalRecord = useSelector((state) => state.cartillaReducer.cartilla);
  const completeProfile = useSelector((state) => state.cartillaReducer.completeProfile);
  const [profileSelected, setProfileSelected] = useState(completeProfile);
  const [mapsExternal, setMaps] = useState(false);
  const history = useHistory();
  const { search, state } = useLocation();
  const match = search.match(/type=(.*)/);
  const trackPageView = useTrackPageView("Cartilla");
  const typeURL = match?.[1];
  const [type, setActiveType] = useState(-1);
  const affiliatePlan = useSelector((state) => state.personalDataReducer?.fullData?.afiliado?.planDescripcion);
  const [ hasPermission, setHasPermission ] = useState(false);
  const loadingPermission = useSelector((state) => state.limitPlanReducer.requestInProgress);
  const limitPlanReducer = useSelector((state) => state.limitPlanReducer.allLimitPlanData);


  const [searchAddress, setSearchAddress] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [noResults, setNoResults] = useState(false);




  const showMapsExternal = (item, i) => (e) => {
    setProfileFunction(item, setProfileSelected);
    if (mapsExternal) {
      setMaps(false);
    } else {
      setMaps(true);
    }
  };


  useEffect(() => {
    if (!state?.fromMap) {
      localStorage.removeItem("modelCartilla");
      localStorage.removeItem("selectedValues");
      localStorage.removeItem("values");
    }
  }, []);


  useEffect(() => {
      const cartillaArray = medicalRecord?.cartilla;
      if (!cartillaArray) {
        setFilteredData([]);
        setNoResults(false);
        return;
      }
  
      const firstSearch = searchAddress.trim().toLowerCase();
  
      if (firstSearch.length < 3) {
        setFilteredData(cartillaArray);
        setNoResults(false);
        return;
      }

      const results = cartillaArray.filter(item => {
        const domicilio = item.prestadorDomicilio?.toLowerCase() || '';
        const barrio = item.prestadorBarrio?.toLowerCase() || '';
  
        const direccionCompleta = `${domicilio} ${barrio}`;
  
        return direccionCompleta.includes(firstSearch);
      });
  
      setFilteredData(results);
      setNoResults(results.length === 0);

    }, [searchAddress, medicalRecord?.cartilla]); 

  useEffect(() => {
    dispatch(getLimitPlan());
    trackPageView();
  }, []);

  useEffect(() => {
    if (profileSelected !== undefined)
      dispatch(getPerfilCompleto(profileSelected));
  }, [profileSelected]);

  useLayoutEffect(() => {
    verifyPermission(limitPlanReducer, affiliatePlan, "Cartilla", setHasPermission);
  }, [limitPlanReducer, affiliatePlan, hasPermission]);

  useEffect(() => {
    dispatch(getFiltersValues(param));
    let numberPerson = window.localStorage.getItem("numeroPersona");
    if (numberPerson) {
      dispatch(getFullData({ numeroPersona: numberPerson }));
    }

    return (() => {
      window.localStorage.removeItem("modelCartilla");
      window.localStorage.removeItem("selectedValues");
      window.localStorage.removeItem("values");
    });
  }, []);


  useEffect(() => {
    window.onpopstate = (e) => {
      dispatch(cleanModelMedicalRecords());
      if (screen.sWidth <= 768 && type !== -1)
        window.location.href = '/MedicalRecords';
      else
        history.push('/');
    };
  });

  useEffect(() => {
    if (typeURL !== undefined) {
      setActiveType(1);
    }
  }, [typeURL]);

  function permissionToEnter(condition) {
    var resp;
    if(condition) {
        resp = (MobileFilters({ medicalRecord, classes, showMapsExternal, screen, mapsExternal, typeURL, history, searchAddress, setSearchAddress, noResults, filteredData}));
    } else {
        resp = (notAccessToThisModule());
    }
    return resp;
  }

  useEffect(() => {
      if (document.getElementById('loadingDiv')) {
        document.getElementById('loadingDiv')?.remove();
    }
  }, []);

  
  return (
    
    <div id="cartilla" className="cartilla-content">
      <div className={`${classes.divFilterCardExternal}    `}>
      {!mapsExternal &&
          (
            loadingPermission  && affiliatePlan?
              <div className={classes.spinerCardExternal}>
                <CircularProgress />
              </div>
            :
              (
                permissionToEnter(hasPermission)
              )
          )
        }

      <SelectTypeOfComponent showMapsExternal={showMapsExternal} mapsExternal={mapsExternal} filteredData={filteredData}  noResults={noResults}/>
      {filteredData && filteredData?.length > 0 &&
        (
          mapsExternal && (
            <>
              <Box className={classes.sectionHeaderCartilla}>
                <IconButton onClick={() => { setMaps(prevState => !prevState); }}>
                  <ArrowBackIcon className={classes.iconFilter} />
                </IconButton>
                <Typography className={classes.titleLabelCartilla} >Cartilla </Typography>
                <Box className={classes.divBtnHeaderCartilla}>
                  <CustomButton
                    typeButton="header"
                    type="submit"
                    title="VER LISTADO"
                    customClass={`${classes.sendButton} ${classes.lightLinearGradient}`}
                    style={{ boxShadow: 'none' }}
                    onClick={() => { setMaps(prevState => !prevState); }}
                  />
                </Box>
              </Box>
              <Divider className={`${classes.formDivider} ${classes.boxDividerCartillaExternal}`} />
              <MapContainer showMapsExternal={showMapsExternal} viewList={true} profileSelected={profileSelected} elevation={0.007}/>
            </>
          )
        )
      }
      </div>
</div>
  );
};

export default Cartilla;

function titleButton(isMaps) {
  return isMaps ? "ver listado" : "ver mapa";
}

function MobileFilters({ medicalRecord, classes, showMapsExternal, screen, isMap, typeURL, history, setSearchAddress }) {
  return (
    <div className={classes.indexCartillSearchExternarl}>
      {screen.sWidth < 768 &&
        setHeaderInMobile({ history, classes, typeURL })
      }
      {((typeURL === undefined && screen.sWidth < 768) || (screen.sWidth > 768)) && <MedicalFiltersExternal isMobile={false}  setSearchAddress={setSearchAddress} />}
        {(medicalRecord.cartilla?.length || 0) > 0 && !isMap && (
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            direction={screen.sWidth < 768 ? 'column-reverse' : 'row'}
            className={classes.labelSearchExternarl}
          >
            {medicalRecord.cartilla?.length > 0 && typeURL !== undefined && (
              <Grid item>
                <CustomButton
                  title={titleButton(isMap)}
                  onClick={showMapsExternal(null, 0)}
                  customClass={`${classes.sendButton} ${classes.lightLinearGradient}`}
                />
              </Grid>
            )}
          </Grid>
        )
      }
    </div>
  );
}

function setHeaderInMobile({ history, classes, typeURL }) {
  let response = (
    <Box style={{ padding: '4%' }}>
      <Typography className={classes.txtTitleCartillaMobile}>Cartilla</Typography>
      <Divider className={`${classes.formDivider} ${classes.boxDivider}`} />
    </Box>);
  if (typeURL !== undefined) {
    response = (
      <Box className={classes.txtIconCartillaExternal}>
        <IconButton onClick={returnHomeAppointmentHome(history)}>
          <ArrowBackIcon className={classes.iconBack} />
        </IconButton>
        <Typography className={classes.txtTitleMobileCartillaExternal}>Cartilla</Typography>
        <Divider className={`${classes.formDivider} ${classes.boxDivider}`} />
      </Box>);
  }

  return response;
}

const returnHomeAppointmentHome = (history) => (e) => {
history.push('/Cartilla', { fromMap: true });};

function setProfileFunction(item, setProfileSelected) {
  item !== null ? setProfileSelected({ PrestadorNumero: item.prestadorNumero }) : setProfileSelected({});
}
